import React from "react";
import { Row, Col, Card, Button, ListGroup, Image } from "react-bootstrap";
import { FaEdit, FaPencilAlt, FaUserEdit } from "react-icons/fa";
import userImage from "../../assets/user-avatar.png"; // Adjust path if necessary

// Accept onAvatarClick prop
const ProfileDetailsCard = ({ user, onEditClick, onAvatarClick }) => {
  const profileFields = [
    { label: "Title", value: user.title, field: "title" },
    // Use user.name and user.surname for display
    // Keep field as 'fname'/'lname' if the API/edit logic expects those keys
    { label: "First Name", value: user.fname, field: "fname" },
    { label: "Last Name", value: user.lname, field: "lname" },
    { label: "Phone", value: user.phone, field: "phone" },
    // Email is handled separately below
  ];

  return (
    <Card className="shadow-sm">
      <Card.Header className="bg-light py-3">
        <Card.Title as="h5" className="mb-0">
          <FaUserEdit className="me-2" /> Profile Details
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Row className="align-items-center">
          <Col md={4} className="text-center mb-4 mb-md-0">
            <div className="position-relative d-inline-block">
              <Image
                src={user.avatar || userImage}
                alt="User Avatar"
                roundedCircle
                thumbnail
                style={{
                  width: "150px",
                  height: "150px",
                  objectFit: "cover",
                }}
              />
              <Button
                variant="light"
                size="sm"
                className="position-absolute bottom-0 end-0 rounded-circle p-2 lh-1"
                onClick={onAvatarClick} // Use onAvatarClick prop
                title="Change Avatar"
                style={{ transform: "translate(25%, 25%)" }}
              >
                <FaEdit />
              </Button>
            </div>
          </Col>

          <Col md={8}>
            <ListGroup variant="flush">
              {profileFields.map(({ label, value, field }) => (
                <ListGroup.Item
                  key={field}
                  className="d-flex justify-content-between align-items-center px-0 py-3"
                >
                  <div>
                    <span className="fw-bold">{label}:</span>
                    {/* Display the value (which now correctly references user.name/user.surname) */}
                    <span className="ms-2 text-muted">{value || "-"}</span>
                  </div>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    // Pass the 'field' name ('fname'/'lname') to onEditClick
                    onClick={() => onEditClick(field, label)}
                    title={`Edit ${label}`}
                  >
                    <FaPencilAlt />
                  </Button>
                </ListGroup.Item>
              ))}
              {/* Special handling for Email edit button to trigger email change flow */}
              <ListGroup.Item className="d-flex justify-content-between align-items-center px-0 py-3">
                <div>
                  <span className="fw-bold">Email:</span>
                  <span className="ms-2 text-muted">{user.email || "-"}</span>
                </div>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => onEditClick("email", "Email")} // Trigger email change flow via onEditClick
                  title="Change Email"
                >
                  <FaPencilAlt />
                </Button>
              </ListGroup.Item>
            </ListGroup>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ProfileDetailsCard;
